import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';

export const PressableTime = Pressable.withConfig<{ $isSelected: boolean }>(p => ({
  minWidth: '$32',
  marginX: '$2',
  background: p.$isSelected
    ? primitive.$bbqBrown
    : getDesignToken('pickup-timed-fire-selector-button-background'),
  borderRadius: primitive.$borderRadius,
  paddingY: '$3',
  paddingX: '$4',
  _pressed: {
    background: primitive.$shadowColor,
  },
  _disabled: {
    background: primitive.$greyTwo,
  },
  _web: {
    cursor: 'pointer',
  },
}));

type TimeTextProps = React.ComponentPropsWithoutRef<typeof Typography> & {
  $isSelected: boolean;
};

export const TimeText = ({ $isSelected, style, ...rest }: TimeTextProps) =>
  React.createElement(Typography, {
    ...rest,
    textAlign: 'center',
    color: $isSelected ? primitive.$white : primitive.$bbqBrown,
    style,
  });
